<div #cardContainer style="display: flex; flex-direction: row;align-items: center; ;gap: 1rem; overflow: hidden">
  <div style="flex: 1 1 auto; display: flex; flex-direction: column; justify-content: space-between">
    <span #textContainer style="display: flex; flex-direction: row; align-items: baseline;">
      <span
        [style.font-size.rem]="adjustFontSize()"
        class="cardData">
        {{ appService.getParsedMetricValue(card) }}
      </span>
      <span [style.font-size.rem]="adjustFontSize() - 0.3" class="cardDataUnit">
        {{ card.dataUnit }}
      </span>
    </span>
  </div>
  <div
    #mainIcon
    style="flex: 1 1 auto; display: flex; flex-direction: column; justify-content: space-between; overflow: hidden; align-items: flex-end;">
    <i
      [style.background-color]="card.color"
      [style.opacity]="mainIcon.offsetWidth < 40 ? 0 : 1"
      style="font-weight: 300;font-optical-sizing: auto;"
      class="vr-ic_fluent_{{card.icon}}_24_regular iconContainer">
    </i>
  </div>
</div>
<div style="flex: 1 1;
                          display: flex;
                          flex-direction: column;
                          gap: 4px;
                          justify-content: space-between;
                          align-items: flex-start;
                          flex-wrap: wrap;">
  <span style="font-size: 1rem;">{{ card.partitionName }} > {{ card.deviceName }} > {{ card.name }}</span>
  <span style="font-size: 1rem;">{{ datePipe.transform(card.lastValueTs, 'dd/MM/yyyy HH:mm') }}</span>
  <div
    *ngIf="metricIsNumeric(card) && !card.dataTypeGroupShowAsHex"
    style="width: 100%;">
    <div style="display: flex; flex-direction: row; justify-content: space-between">
      <span>{{ card.minVal }}</span>
      <span>{{ card.maxVal }}</span>
    </div>
    <mat-progress-bar
      *ngIf="card.minVal !== undefined && card.maxVal !== undefined"
      [value]="calculatePercentageValue(card.lastValue, card.minVal, card.maxVal)" class="progressBar"
      mode="determinate">
    </mat-progress-bar>
  </div>
</div>
